import { logger } from '@accedo/logger';
import { MenuItem } from '##/dataModels/menuItem';
import { PageLayout } from '##/dataModels/pageLayout';
import { Route } from '##/dataModels/route';
import { ServiceManager } from '##/services/elevate/manager';
import { config } from '##/services/store';

const LP = '[AppContent]';

export const loadMenuItems = async (): Promise<MenuItem[]> => {
  const cachedMenuItems: MenuItem[] | undefined = config.getByKey<MenuItem[] | undefined>('menuItems');

  if (cachedMenuItems) {
    return cachedMenuItems;
  }

  const menuItems = await ServiceManager.getCmsService().getMenu();
  logger.debug(`${LP} menu retrieved `, JSON.stringify(menuItems));
  config.set({ menuItems });

  return menuItems;
};

/*
Maps route paths to pages, this is used to determine which page to render based on the current route.
*/
export const loadRoutes = async (): Promise<Route[]> => {
  const cachedRoutes: Route[] | undefined = config.getByKey<Route[] | undefined>('routes');

  if (cachedRoutes) {
    return cachedRoutes;
  }

  const routes = await ServiceManager.getCmsService().getRoutes();
  config.set({ routes });
  return routes;
};

/**
 * We will now also grab the full pageLayout for the default page
 * whilst the splash screen is still visible and then route to that page
 * the object key is the route e.g. / or /movies etc.
 * Needs to be synchronous after the loadRoutes call.
 */

export const loadDefaultPageLayout = async (defaultRoute: string): Promise<PageLayout> => {
  const cachedDefaultPageLayout = config.getByKey<PageLayout | undefined>('defaultRoute');

  if (cachedDefaultPageLayout) {
    return cachedDefaultPageLayout;
  }

  const defaultPageLayout = await ServiceManager.getCmsService().getPageLayout(defaultRoute);
  config.setByKey('/', defaultPageLayout);

  return defaultPageLayout;
};
